import { host } from '../config/env'
/**
 * 创建场景
 */
export const creatScene = params => {
  return axios({
    url: `${host.h5sApi}/m/e/scene/create`,
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 * 创建海报
 * @param params
 * @returns {*}
 */
export const createH2 = params => {
  return axios({
    url: `${host.p1}/m/print/create`,
    method: 'post',
    headers: {
      'Content-Type': 'text/plain; charset=UTF-8'
    },
    data: {
      ...params
    }
  })
}

/**
 * 创建长页
 * @param params
 * @returns {*}
 */
export const createH5l = params => {
  return axios({
    url: `${host.lpservice}/m/lp/create`,
    method: 'post',
    data: {
      ...params
    }
  })
}

/**
 * 创建表单
 * @param params
 * @returns {*}
 */
export const createH5e = params => {
  return axios({
    url: `${host.lpservice}/m/lp/create`,
    method: 'post',
    params: {
      bizType: 1
    },
    data: {
      ...params
    }
  })
}
/**
 * 获取可创建的海报分类
 * @returns {*}
 */
export const printSizeList = () => {
  return axios({
    url: `${host.p1}/print/dictionary/print_size_list`,
    method: 'get'
  })
}
